import script from "./ThemeSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeSelector.vue?vue&type=script&setup=true&lang=js"

import "./ThemeSelector.vue?vue&type=style&index=0&id=78a84b0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78a84b0d"]])

export default __exports__